import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState, } from 'react';
import styled from 'styled-components';
import Notice from '../../molecules/Notice';
import { ToastContext } from './ToastContext';
const ToastStackContainer = styled.div `
    position: fixed;
    bottom: 1rem;
    right: 1rem;
    z-index: 5;
`;
export function ToastProvider({ children }) {
    const [toastStack, setToastStack] = useState([]);
    const hasToasts = Boolean(toastStack.length);
    const add = (toast) => {
        setToastStack(toasts => [toast, ...toasts]);
    };
    const timer = React.useRef();
    useEffect(() => {
        if (hasToasts) {
            timer.current = window.setTimeout(() => {
                setToastStack(toasts => toasts.slice(0, -1));
                timer.current = void 0;
            }, 7000);
        }
        return () => {
            if (timer.current != null)
                window.clearTimeout(timer.current);
        };
    }, [toastStack, hasToasts]);
    return (_jsxs(ToastContext.Provider, { value: { add }, children: [_jsx(_Fragment, { children: children }), hasToasts && (_jsx(ToastStackContainer, { children: toastStack.map((toast, index) => (_jsx(Notice, { ...toast }, index))) }))] }));
}
